import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useAuth } from '~/lib/auth';
import { Card, CardBody, CardHeader } from '~/components/ui';

export const Route = createFileRoute('/_app/admin')({
  component: AdminLayout,
});

function AdminLayout() {
  const { profile, loading } = useAuth();
  const roles = (profile?.staff_role_keys as string[] | null) ?? [];

  if (!loading && profile && !roles.includes('admin')) {
    return (
      <div className="px-6 py-6 max-w-7xl mx-auto w-full">
        <Card>
          <CardHeader>No access</CardHeader>
          <CardBody>
            <div className="text-sm text-[var(--color-ink-muted)]">
              The Admin area is restricted to administrators.
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }

  // Single layout fix: each admin route ships its own `max-w-* mx-auto` wrapper.
  // The `admin-fullwidth` class (globals.css) neutralizes that centering for the
  // whole admin area so tab content stretches to the full content width.
  return (
    <div className="admin-fullwidth">
      <Outlet />
    </div>
  );
}
